import { render, staticRenderFns } from "./AccountConfirmationComponent.vue?vue&type=template&id=1b382f40&"
import script from "./AccountConfirmationComponent.vue?vue&type=script&lang=js&"
export * from "./AccountConfirmationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports